import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { CurrentUserContext } from '../../../context/CurrentUserContext';

const CourseView = () => {
  const [course, setCourse] = useState({});
  const [loading, setLoading] = useState<boolean>(false);
  const [video, setVideo] = useState({});
  const [isVideo,setIsVideo]= useState<boolean>(false)
  const [values, setValues] = useState({
    title: "",
    content: "",
    video: {}
  })
  const params = useParams();
  const courseName = params.name;
  const { currentUser } = useContext(CurrentUserContext);
  
  
  useEffect(() => {
    async function fetchData() {
      const response = await fetch(`https://api-j06q.onrender.com/api/course/course/${courseName}`)
      const data = await response.json();
      
      setCourse(data)
    }
    fetchData();
  },[courseName])
  
  const handleAddLesson = async(e: React.SyntheticEvent) => {
      e.preventDefault();
    try {
        console.log("We are here");
        
        const response = await fetch(`https://api-j06q.onrender.com/api/course/lesson/${courseName}/${currentUser._id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json'
          },
          body: JSON.stringify({ values })
        });
        const data = await response.json();
        console.log(data);
        setValues({ ...values, video: {} })
        setVideo({});
        setIsVideo(false);
        setCourse(data);
      } catch (error) {
        console.log(error);
        
      }
      
  }

  const handleVideo = async(e:React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    e.preventDefault();
    if (!e.target.files) return;
    let file = e.target.files[0];
    const videoData = new FormData();
    videoData.append('file', file)

    
    try {
      
      let response = await fetch("https://api-j06q.onrender.com/api/course/videoUpload", {
        method: "POST",
        body: videoData
      });
      const data = await response.json();
      setLoading(false);
      setValues({ ...values, video: data })
      setVideo(data);
      setIsVideo(true);
      
    } catch (error) {
      console.log(error);
      
    }
    
  }

  const handleRemoveVideo = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    try {
      let response = await fetch("https://api-j06q.onrender.com/api/course/videoRemove", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json'
        },
        body: JSON.stringify({ video })
      });
      const data = await response.json();
      console.log(data);
      setValues({ ...values, video: {} })
      setVideo({});
      setIsVideo(false);
    } catch (error) {
      console.log(error);
      
    }
    
    
  }
  return (
    <div>
      <h1>{courseName}</h1>
      <pre>{JSON.stringify(course, null, 4)}</pre>
      <button >Add Lesson</button>
      <form onSubmit={handleAddLesson}>
        <input type="text" onChange={(e) => setValues({ ...values, title: e.target.value })} value={values.title} placeholder="Title" required />
        
        <textarea cols={30} rows={10} onChange={(e) => setValues({ ...values, content: e.target.value })} value={values.content} placeholder="Content" />
        <input type="file" accept='video/*' placeholder='Upload Video' onChange={handleVideo} />
        {isVideo && 
        <button onClick={handleRemoveVideo}>Remove Video</button>
        }
        <button onClick={handleAddLesson}>Save</button>
      </form>
    </div>
  )
}

export default CourseView
